const FOCUSABLE =
  'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

export function getFocusable(container: HTMLElement): HTMLElement[] {
  return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE)).filter(
    (el) => !el.hasAttribute('disabled') && el.offsetParent !== null,
  )
}

/** Trap Tab within `container`; restore `previousFocus` on cleanup. */
export function trapFocus(container: HTMLElement, previousFocus: Element | null): () => void {
  const focusables = getFocusable(container)
  const first = focusables[0]
  const last = focusables[focusables.length - 1]

  if (first) first.focus()
  else container.focus()

  function onKeyDown(e: KeyboardEvent): void {
    if (e.key !== 'Tab') return
    if (focusables.length === 0) {
      e.preventDefault()
      return
    }
    if (e.shiftKey) {
      if (document.activeElement === first || document.activeElement === container) {
        e.preventDefault()
        last?.focus()
      }
    } else if (document.activeElement === last) {
      e.preventDefault()
      first?.focus()
    }
  }

  container.addEventListener('keydown', onKeyDown)
  return () => {
    container.removeEventListener('keydown', onKeyDown)
    if (previousFocus instanceof HTMLElement) previousFocus.focus()
  }
}
